import Vue from 'vue';

export default (context) => {
  context.airbnbActiveLoading = true;
  return Vue.$http.post('/airbnb/connection-link', {
    'callback_url': context.callback_url,
  })
    .then(response => {
      context.redirectlink = response.data.link;
    })
    .catch(error => {
    console.log( error.response.data);
    })
    .finally(() => {
    });
}



// WEBPACK FOOTER //
// ./src/app/services/airbnb/connection-link.js